export const environment = {
  production: false,
  apiUrl: '#{ApiUrl}#',
  notificationApiUrl: '#{NotificationApiUrl}#',
  deviceInfoUrl: '#{DeviceInfoUrl}#',
  featureFlags: {
    enableNotification: true,
    isDeviceVerificationEnabled: true
  }
  
};
